package com.exura.features.firebase.usecase

import com.exura.features.newauth.domain.manager.AuthManager
import com.exura.features.newauth.domain.model.AuthState
import dev.gitlive.firebase.firestore.DocumentReference
import dev.gitlive.firebase.firestore.FirebaseFirestore
import dev.gitlive.firebase.storage.FirebaseStorage
import dev.gitlive.firebase.storage.StorageReference
import kotlinx.coroutines.flow.filterIsInstance
import kotlinx.coroutines.flow.first
import kotlinx.coroutines.flow.mapNotNull

class GetUserFilesPrefixUseCase(
    private val authManager: AuthManager,
    private val storage: FirebaseStorage,
) {

    suspend operator fun invoke(): Result<StorageReference> = runCatching {
        val user = authManager.state
            .filterIsInstance<AuthState.Authenticated>()
            .mapNotNull { it.user }
            .first()
        storage.reference.child(user.userRole.id).child(user.id)
    }
}
